import { render, staticRenderFns } from "./tack.vue?vue&type=template&id=59b1ec20&scoped=true"
import script from "./tack.vue?vue&type=script&lang=js"
export * from "./tack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b1ec20",
  null
  
)

export default component.exports